import {PageMap} from '@wix/wixstores-client-core';
import {SiteStore} from '@wix/wixstores-client-storefront-sdk';
import {ControllerParams} from '@wix/yoshi-flow-editor';
import {BIService} from '../services/BIService';
import {CartService} from './CartService';
import {ContinueShoppingBiOrigin} from '../../common/constants';
import {ICartControllerApi} from '../../types/app.types';
import {ModalManagerService} from './ModalManagerService';

export class NavigationService {
  private readonly controllerApi: ICartControllerApi;
  public get isNavigationToCheckoutInProcess(): boolean {
    return this._isNavigationToCheckoutInProcess;
  }

  public set isNavigationToCheckoutInProcess(value: boolean) {
    this._isNavigationToCheckoutInProcess = value;
    void this.controllerApi.updateComponent();
  }
  private readonly siteStore: SiteStore;
  private readonly biService: BIService;
  private readonly publicData: ControllerParams['controllerConfig']['config']['publicData'];
  private readonly windowApi: ControllerParams['controllerConfig']['wixCodeApi']['window'];
  private readonly cartService: CartService;
  public readonly modalManagerService: ModalManagerService;
  private _isNavigationToCheckoutInProcess: boolean = false;

  constructor({
    siteStore,
    biService,
    cartService,
    publicData,
    controllerApi,
    modalManagerService,
    controllerParams,
  }: {
    siteStore: SiteStore;
    biService: BIService;
    cartService: CartService;
    modalManagerService: ModalManagerService;
    publicData: ControllerParams['controllerConfig']['config']['publicData'];
    controllerApi: ICartControllerApi;
    controllerParams: ControllerParams;
  }) {
    this.siteStore = siteStore;
    this.cartService = cartService;
    this.biService = biService;
    this.publicData = publicData;
    this.controllerApi = controllerApi;
    this.modalManagerService = modalManagerService;
    this.windowApi = controllerParams.controllerConfig.wixCodeApi.window;
  }

  public readonly closeSideCart = () => {
    (this.windowApi.lightbox as any).close();
  };

  private get continueShoppingLinkObject() {
    return this.publicData.COMPONENT.CART_CONTINUE_SHOPPING_LINK_OBJECT;
  }

  public readonly continueShopping = async (origin = ContinueShoppingBiOrigin.shoppingCart) => {
    this.biService.cartClickOnContinueShoppingSf(this.cartService.cartModel, this.cartService.estimatedTotals, origin);
    this.siteStore.navigateToLink(await this.getLink());
  };

  public readonly navigateToCart = async () => {
    this.biService.clickToViewCartPage(this.cartService.cartModel, this.cartService.cartType);
    const to = {sectionId: PageMap.CART};
    return this.siteStore.navigate(to, true);
  };

  private getLink() {
    return this.continueShoppingLinkObject
      ? this.siteStore.getLink(this.continueShoppingLinkObject)
      : this.siteStore.getHomepageLink();
  }

  /* istanbul ignore next */
  public async getContinueShoppingHref() {
    try {
      return (await this.getLink()).url;
    } catch {
      //
    }
    return '#';
  }

  /* istanbul ignore next */
  public readonly navigateToProduct = (urlPart: string) => {
    const to = {sectionId: PageMap.PRODUCT, state: urlPart};
    return this.siteStore.navigate(to, true);
  };

  public readonly navigateToFullProductUrl = (url: string) => {
    return this.siteStore.navigateToLink({
      sdkLink: {type: 'ExternalLink', target: '_top', url},
      url,
    });
  };
}
